export default "__VITE_ASSET__DEYST726__"